import { DataSourceWithNetworks } from "@syla/shared/types/responses/DataSourceWithNetworks";
import axios from "axios";

export async function getDataSources(): Promise<DataSourceWithNetworks[]> {
  const { data } = await axios.get("/data-sources");
  return data;
}
